import { render, staticRenderFns } from "./centerForm.vue?vue&type=template&id=3f4e0e33&scoped=true"
import script from "./centerForm.vue?vue&type=script&lang=js"
export * from "./centerForm.vue?vue&type=script&lang=js"
import style0 from "./centerForm.vue?vue&type=style&index=0&id=3f4e0e33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4e0e33",
  null
  
)

export default component.exports